import { PaymentRedriveApiFactory } from "../../../lusca-search-api/LuscaSearchApiFactory";
import { Stage } from "../../../lusca-search-api/generated-src";

export const useExecutePaymentRedrive = () => {
  const uploadAndExecuteRedrive = async (file: File, stage: Stage) => {
    const paymentRedriveApi = PaymentRedriveApiFactory();

    const uploadUrlResponse =
      await paymentRedriveApi.getPaymentRedriveUploadUrl(stage, file.name);

    if (!uploadUrlResponse.data?.uploadUrl || !uploadUrlResponse.data?.s3Uri) {
      throw new Error("Failed to get upload URL");
    }

    const uploadResponse = await fetch(uploadUrlResponse.data.uploadUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": "text/csv",
      },
    });

    if (!uploadResponse.ok) {
      throw new Error("Failed to upload file to S3");
    }

    return paymentRedriveApi.postPaymentRedriveBulk(stage, {
      s3_uri: uploadUrlResponse.data.s3Uri,
    });
  };

  const executeRedrive = async (
    file: File,
    selectedStage: Stage,
    setSelectedExecutionId: (id: string | null) => void,
    setError: (error: string) => void
  ) => {
    try {
      const response = await uploadAndExecuteRedrive(file, selectedStage);

      if (response.data && response.data.executionId) {
        setSelectedExecutionId(response.data.executionId);
        window.history.pushState(
          {},
          "",
          `?stage=${encodeURIComponent(
            selectedStage
          )}&executionId=${encodeURIComponent(response.data.executionId)}`
        );
      } else {
        window.location.reload();
      }
    } catch (err) {
      setError(
        `Failed to execute redrive: ${
          err instanceof Error ? err.message : String(err)
        }`
      );
    }
  };

  return { executeRedrive };
};
